var _a;
export var EFootballSchoolStaffType;
(function (EFootballSchoolStaffType) {
    EFootballSchoolStaffType["COACH"] = "COACH";
    EFootballSchoolStaffType["TECHNICAL_COACH"] = "TECHNICAL_COACH";
    EFootballSchoolStaffType["GOALKEEPER_COACH"] = "GOALKEEPER_COACH";
    EFootballSchoolStaffType["ASSISTANT_COACH"] = "ASSISTANT_COACH";
    EFootballSchoolStaffType["PHYSIOTHERAPIST"] = "PHYSIOTHERAPIST";
    EFootballSchoolStaffType["EQUIPMENT_MANAGER"] = "EQUIPMENT_MANAGER";
    EFootballSchoolStaffType["HEAD_OF_FOOTBALL_SCHOOL"] = "HEAD_OF_FOOTBALL_SCHOOL";
    EFootballSchoolStaffType["SECRETARY"] = "SECRETARY";
    EFootballSchoolStaffType["DIRECTOR_OF_FOOTBALL_SCHOOL"] = "DIRECTOR_OF_FOOTBALL_SCHOOL";
    EFootballSchoolStaffType["CONDITIONING_COACH"] = "CONDITIONING_COACH";
    EFootballSchoolStaffType["ANALYST"] = "ANALYST";
    EFootballSchoolStaffType["VIDEO_ANALYST"] = "VIDEO_ANALYST";
    EFootballSchoolStaffType["HEAD_OF_TALENT_DEVELOPMENT"] = "HEAD_OF_TALENT_DEVELOPMENT";
    EFootballSchoolStaffType["HEAD_SCOUT"] = "HEAD_SCOUT";
})(EFootballSchoolStaffType || (EFootballSchoolStaffType = {}));
export var staffTypeTranslations = (_a = {},
    _a[EFootballSchoolStaffType.COACH] = {
        sl: "Trener",
        en: "Coach"
    },
    _a[EFootballSchoolStaffType.TECHNICAL_COACH] = {
        sl: "Tehnični vodja",
        en: "Technical Coach"
    },
    _a[EFootballSchoolStaffType.GOALKEEPER_COACH] = {
        sl: "Trener vratarjev",
        en: "Goalkeeper Coach"
    },
    _a[EFootballSchoolStaffType.ASSISTANT_COACH] = {
        sl: "Pomočnik trenerja",
        en: "Assistant Coach"
    },
    _a[EFootballSchoolStaffType.PHYSIOTHERAPIST] = {
        sl: "Fizioterapevt",
        en: "Physiotherapist"
    },
    _a[EFootballSchoolStaffType.EQUIPMENT_MANAGER] = {
        sl: "Ekonom",
        en: "Equipment Manager"
    },
    _a[EFootballSchoolStaffType.HEAD_OF_FOOTBALL_SCHOOL] = {
        sl: "Športni direktor",
        en: "Head of Football School"
    },
    _a[EFootballSchoolStaffType.SECRETARY] = {
        sl: "Sekretar",
        en: "Secretary"
    },
    _a[EFootballSchoolStaffType.DIRECTOR_OF_FOOTBALL_SCHOOL] = {
        sl: "Direktor",
        en: "Director"
    },
    _a[EFootballSchoolStaffType.CONDITIONING_COACH] = {
        sl: "Kondicijski trener",
        en: "Conditioning Coach"
    },
    _a[EFootballSchoolStaffType.ANALYST] = {
        sl: "Analitik",
        en: "Analyst"
    },
    _a[EFootballSchoolStaffType.VIDEO_ANALYST] = {
        sl: "Video analitik",
        en: "Video Analyst"
    },
    _a[EFootballSchoolStaffType.HEAD_OF_TALENT_DEVELOPMENT] = {
        sl: "Vodja razvoja stroke in igralcev",
        en: "Head of Talent Development"
    },
    _a[EFootballSchoolStaffType.HEAD_SCOUT] = {
        sl: "Vodja skavtske službe",
        en: "Head Scout"
    },
    _a);
export function EFootballSchoolStaffTypeToFriendlyName(type, language) {
    if (language === void 0) { language = 'sl'; }
    return staffTypeTranslations[type][language] || staffTypeTranslations[type].sl;
}
